// cdl-article.js
// Barre de progression de lecture pour les articles de blog - Ciel de Lin

document.addEventListener('DOMContentLoaded', function () {
  const progressBar = document.querySelector('.cdl-reading-progress');
  const article = document.querySelector('.article-template__content');

  if (!progressBar || !article) return;

  function updateProgress() {
    const articleTop = article.getBoundingClientRect().top + window.scrollY;
    const articleHeight = article.offsetHeight;
    const windowHeight = window.innerHeight;
    const scrolled = window.scrollY;

    const start = articleTop;
    const end = articleTop + articleHeight - windowHeight;

    if (scrolled < start) {
      progressBar.style.width = '0%';
    } else if (scrolled > end) {
      progressBar.style.width = '100%';
    } else {
      const progress = ((scrolled - start) / (end - start)) * 100;
      progressBar.style.width = progress + '%';
    }
  }

  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();
});
